<div class="modal-padding">
  <p class="advanced-filters-message">
    The following advanced filters can include multiple comma separated values. If any of the terms are an exact match
    on a product, the product will be included.
  </p>
  <lib-reactive-form-group [bindTo]="bindTo" [mergeKey]="mergeKey">
    <lib-reactive-form-column-layout [nColumns]="2">
      <lib-reactive-form-pill-drop-down
        [inputName]="'effects'"
        [label]="'Mood'"
        [bindingProperty]="'effects'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.groupDetailEffect$ | async"
        [placeholder]="'Mood (ie: Alert, Anxious, Aroused)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'helpsWith'"
        [label]="'Helps With'"
        [bindingProperty]="'helpsWith'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.groupDetailHelpsWith$ | async"
        [placeholder]="'Helps With (ie: ADD/ADHD, Anxiety, Arthritis)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'aroma'"
        [label]="'Aroma'"
        [bindingProperty]="'aromas'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.groupDetailAromaFlavor$ | async"
        [placeholder]="'Aroma (ie: Almond, Banana, Candy)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'appearance'"
        [label]="'Appearance'"
        [bindingProperty]="'appearances'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.groupDetailAppearance$ | push"
        [placeholder]="'Appearance (ie: Airy, Bright Orange Hairs, Chunky)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'growingConditions'"
        [label]="'Growing Conditions'"
        [bindingProperty]="'growingConditions'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.groupDetailGrowingCondition$ | push"
        [placeholder]="'Growing Conditions (ie: Indoor, Outdoor, Greenhouse)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'craftingDesignation'"
        [label]="'Craft Designation'"
        [bindingProperty]="'craftDesignations'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.craftDesignations$ | push"
        [placeholder]="'Craft Designation (ie: BC Craft Farmers Co-op, OSC Craft)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'energyScores'"
        [label]="'Energy Score'"
        [bindingProperty]="'energyScores'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [addToAtLeastNItemsFilledInPool]="true"
        [dropdowns]="viewModel.groupDetailEnergyScore$ | push"
        [placeholder]="'Energy Score (ie: 0 , 5, 10)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'pricingCodes'"
        [label]="'Pricing Code'"
        [placeholder]="'Pricing code of product active price (ie: 0.98, 0.99)'"
        [inlineLabel]="false"
        [disabled]="viewModel.isViewOnly$ | async"
        [tooltip]="'The smart filter will include products that exactly match one of the pricing tiers (comma separated)'"
        [addToAtLeastNItemsFilledInPool]="true"
        [bindingProperty]="'pricingCodes'"
        [dispersedKey]="mergeKey"
        [delimiter]="','"
        [submitAsDelimitedString]="false"
        [userCanAddNewDelimitedItems]="true"
        [hideAllItemsFromSearchList]="true"
        [newlyAddedDelimitedItemsMustBeNumbers]="{
          on: true,
          maxCharacters: 4,
          maxNumberOfDecimals: 2,
          alwaysOutputNDecimalPlaces: 2,
          forceMinValue: 0,
          forceMaxValue: 0.99,
          outputArrayElementsAs: 'numbers',
          visuallyPadDecimalToNthDecimalPlace: 2
        }"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'flavorGroups'"
        [label]="'Top Flavor'"
        [bindingProperty]="'flavorGroups'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [dropdowns]="viewModel.groupDetailAromaFlavor$ | push"
        [placeholder]="'Flavor (ie: Citrus, Fruity, Spicy)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'flavor'"
        [label]="'Flavor'"
        [bindingProperty]="'flavors'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [dropdowns]="viewModel.groupDetailAromaFlavor$ | push"
        [placeholder]="'Flavor (ie: Citrus, Fruity, Spicy)'"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'productTagGroups'"
        [label]="'Product Tag Groups'"
        [bindingProperty]="'tagGroupIds'"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [dropdowns]="viewModel.productTagGroups$ | push"
        [placeholder]="'Tag Groups (ie: Edibles, Sugar)'"
        [clearable]="true"
        [emitInitializationValuesAsValueChanged]="true"
        [addToAtLeastNItemsFilledInPool]="true"
        (valueChanged)="viewModel.connectToSelectedTagGroupIds($event)">
      </lib-reactive-form-pill-drop-down>

      <lib-reactive-form-pill-drop-down
        [inputName]="'productTags'"
        [label]="'Product Tags'"
        [bindingProperty]="'tagIds'"
        [pillPlaceholders]="viewModel.selectedTagGroupProductTags$ | push"
        [alwaysShowPillPlaceholders]="{
          overlapOfPlaceholderAndSelectionWillShow: 'Placeholder',
          unselectOverlap: true,
          dropDownListOptions: {
            disablePillPlaceholders: true,
            disabledPillPlaceholdersAppearAsSelected: true
          }
        }"
        [disabled]="viewModel.isViewOnly$ | async"
        [dispersedKey]="mergeKey"
        [dropdownGroupings]="viewModel.curatedTagGroupDropdownGroupings$ | push"
        [dropdowns]="viewModel.curatedProductTagsWhereSelectionIsId$ | push"
        [placeholder]="'Tags (ie: Low Sugar, Mid Sugar)'"
        [addToAtLeastNItemsFilledInPool]="true"
        [clearable]="true">
      </lib-reactive-form-pill-drop-down>

      <ng-container *rxFor="let provider of viewModel.gradingProviders$; trackBy: viewModel.trackByProvider">
        <lib-reactive-form-number
          #min
          [inputName]="'minVal' | randomString"
          [label]="'Minimum ' + provider.name + ' Grade'"
          [minValue]="
            (provider.value | getGradingScoreMetadataProperty: (viewModel.gradingProviders$ | push) : 'minVal') ??
            minDefaultGradingScore
          "
          [maxValue]="
            provider.value
              | getGradingScoreMetadataProperty: (viewModel.gradingProviders$ | push) : 'maxVal'
              | minimumGradingScoreMaxValue
                : (max.valueChanged | async)
                : minDefaultGradingScore
                : maxDefaultGradingScore
          "
          [bindingProperty]="'gradingResults'"
          [bindingPropertyMapKey]="provider.value"
          [mapValueBindingProperty]="'minVal'"
          [placeholder]="'Enter minimum ' + provider.name + ' grade score'"
          [addToAtLeastNItemsFilledInPool]="true"
          [emitInitializationValuesAsValueChanged]="true"
          [showErrorMessagesOnInitialization]="true"
          [dispersedKey]="mergeKey"
          (valueChanged)="viewModel.connectToMinGradingScore($event)">
        </lib-reactive-form-number>

        <lib-reactive-form-number
          #max
          [inputName]="'maxVal' | randomString"
          [label]="'Maximum ' + provider.name + ' Grade'"
          [bindingProperty]="'gradingResults'"
          [bindingPropertyMapKey]="provider.value"
          [mapValueBindingProperty]="'maxVal'"
          [placeholder]="'Enter maximum ' + provider.name + ' grade score'"
          [minValue]="
            provider.value
              | getGradingScoreMetadataProperty: (viewModel.gradingProviders$ | push) : 'minVal'
              | maximumGradingScoreMinValue
                : (min.valueChanged | async)
                : minDefaultGradingScore
                : maxDefaultGradingScore
          "
          [maxValue]="
            (provider.value | getGradingScoreMetadataProperty: (viewModel.gradingProviders$ | push) : 'maxVal') ??
            maxDefaultGradingScore
          "
          [addToAtLeastNItemsFilledInPool]="true"
          [dispersedKey]="mergeKey"
          (valueChanged)="viewModel.connectToMaxGradingScore($event)">
        </lib-reactive-form-number>
      </ng-container>
      <lib-reactive-form-switch
        style="align-self: center"
        class="mt-2"
        [label]="'Active Sale'"
        [addToAtLeastNItemsFilledInPool]="true"
        [bindingProperty]="'activeSale'"
        [inputName]="'activeSale'"
        [disabled]="viewModel.isViewOnly$ | async"
        [tooltip]="'The smart filter will only include products on sale.'">
      </lib-reactive-form-switch>

      <lib-reactive-form-switch
        style="align-self: center"
        class="mt-2"
        [label]="'Require Pricing Tier'"
        [addToAtLeastNItemsFilledInPool]="true"
        [bindingProperty]="'requirePricingTier'"
        [inputName]="'pricingTier'"
        [disabled]="viewModel.isViewOnly$ | async"
        [tooltip]="'The smart filter will only include products with pricing tiers.'">
      </lib-reactive-form-switch>
    </lib-reactive-form-column-layout>

    <div class="label-badge-container">
      <app-inline-labels-picker class="mt-3" [bindTo]="bindTo" [mergeKey]="mergeKey"></app-inline-labels-picker>

      <div class="mt-3">
        <app-badge-picker-for-form
          [inputName]="'badgePicker'"
          [bindingProperty]="'badgeIds'"
          [badges]="viewModel?.hydratedBadgesOnSmartFilter$ | push"
          [popperPlacement]="Types.NgxFloatUiPlacements.RIGHT">
        </app-badge-picker-for-form>
      </div>
    </div>
  </lib-reactive-form-group>
</div>
